<footer class="footer">
  <div class="footer__left">
    <p class="footer__left__paragraph"><strong>¿Tienes problemas?</strong> Comunicate con la Mesa de Ayuda:</p>
    <a [href]="'app.footer.href' | translate" class="footer__left__link">{{ 'app.footer.helphone' | translate }}</a>
  </div>

  <img class="footer__center-logo" src="images/logos/sodimac-footer.png" alt="">

  <div class="footer__right">
    <p class="footer__right__paragraph">Servicios hogar, lo hacemos por ti.</p>
    <p class="footer__right__paragraph"><span>® {{ date() | date: 'yyyy' }} Sodimac S. A. | Version: {{ version() }}</span></p>
  </div>
</footer>
